import React from "react";
import { Button, ButtonProps, Grid, Typography } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../store";
import { savePreferences } from "../../store/expertise/expertise.action";
import { NumFactuValidator } from "../../../core/validators/num.factu.validator";
import { ClotureAfterValidator } from "../../../core/validators/cloture.after.validator";
import { NonNegativeIntegerValidator } from "../../../core/validators/non.negative.integer.validator";
import { MssAdresseValidator } from "../../../core/validators/mss.adresse.validator";
import { EnvoiSyntheseTleMode } from "../../../core/apis/monsisra/generated";
import { hasAuthorizedProfessionOrSpecialite } from "../../../core/utils/professions.specialites.utils";

function Btn(props: { label: string; onClick: () => void } & ButtonProps) {
	return (
		<Button {...props} className={"btn"} sx={{ color: "white" }} variant={"contained"} color={"secondary"} onClick={props.onClick}>
			{props.label}
		</Button>
	);
}

export function SubmitCancel() {
	const dispatch = useAppDispatch();

	const { preferences, useMonSisra } = useAppSelector((s) => ({
		preferences: s.expertise.preferences,
		useMonSisra: s.expertise.useMonSisra,
	}));

	const [canSubmit, setCanSubmit] = React.useState(true);
	const [isFormValid, setIsFormValid] = React.useState(false);
	const [errorMessage, setErrorMessage] = React.useState("");

	React.useEffect(() => {
		let valid = true;
		if (preferences?.statutDansAnnuaire) {
			if (!preferences?.description?.length) valid = false;
			if (!useMonSisra && (preferences?.urlOutil == null || preferences?.urlOutil?.length === 0)) valid = false;
			if (preferences.numeroFacturation && !NumFactuValidator.validate(preferences.numeroFacturation)) {
				valid = false;
				setErrorMessage("Le numéro de facturation n'est pas valide");
			}
			if (preferences.preferencesClotureAuto?.clotureAuto && !ClotureAfterValidator.validate(preferences.preferencesClotureAuto?.clotureAfter)) valid = false;
			else {
				setErrorMessage("");
			}
			if (preferences.preferencesRestriction?.dailyTeleExpertiseLimitEnabled && !NonNegativeIntegerValidator.validate(preferences.preferencesRestriction?.maxTlePerDay))
				valid = false;
			const restriction = preferences.preferencesRestriction;
			if (restriction?.limitToAutorizedProfessionsAndSpecialites && !hasAuthorizedProfessionOrSpecialite(restriction)) valid = false;

			// Validation adresse MSS tierce
			const envoiPref = preferences.preferencesEnvoiSyntheseTleExpert;
			if (envoiPref && envoiPref.modeEnvoiMss === EnvoiSyntheseTleMode.TO_TIERCE) {
				// Mode "tierce" sélectionné : l'adresse doit être remplie et valide
				if (!MssAdresseValidator.validate(envoiPref.mssTierce)) {
					valid = false;
				}
			}
		}
		setIsFormValid(valid);
	}, [preferences, useMonSisra]);

	const save = React.useCallback(() => {
		if (canSubmit && isFormValid) {
			setCanSubmit(false);
			dispatch(savePreferences()).then((action) => {
				setCanSubmit(true);
				if (savePreferences.fulfilled.match(action)) window.dispatchEvent(new Event("teleexpertise-preferences-saved"));
			});
		}
	}, [dispatch, canSubmit, isFormValid]);

	React.useEffect(() => {
		const listener = (ev: { data: { eventName: string } }) => {
			if (ev.data["eventName"] === "modulesante-teleexpertise-submit") {
				save();
			}
		};
		window.addEventListener("message", listener);
		return () => window.removeEventListener("message", listener);
	}, [save]);

	if (!preferences) return null;

	return (
		<Grid className={"SubmitCancel"} container spacing={2}>
			<Grid item>
				<Btn label={"Enregistrer"} onClick={save} disabled={!canSubmit || !isFormValid} />
				{errorMessage && (
					<Typography color="error" variant="body2" sx={{ mt: 1 }}>
						{errorMessage}
					</Typography>
				)}
			</Grid>
		</Grid>
	);
}
